import { startOfMonth as dateFnsStartOfMonth, endOfMonth as dateFnsEndOfMonth, startOfWeek as dateFnsStartOfWeek, endOfWeek as dateFnsEndOfWeek, startOfDay as dateFnsStartOfDay, endOfDay as dateFnsEndOfDay, eachWeekOfInterval as dateFnsEachWeekOfInterval, eachDayOfInterval as dateFnsEachDayOfInterval, addYears, startOfYear as dateFnsStartOfYear, isBefore, isAfter, isSameDay, isSameYear, } from 'date-fns';
/**
 * Some date-fns functions don't keep the current time of the dates, so we apply it manually
 * This is to support timezone differences
 */
const transformDateWithOriginalTime = (options) => {
    const { originalDate, newDate } = options;
    newDate.setHours(originalDate.getHours());
    newDate.setMinutes(originalDate.getMinutes());
    newDate.setSeconds(originalDate.getSeconds());
    newDate.setMilliseconds(originalDate.getMilliseconds());
    return newDate;
};
export function startOfYear(options) {
    const { date } = options;
    const newDate = dateFnsStartOfYear(date);
    return transformDateWithOriginalTime({ originalDate: date, newDate });
}
export function startOfMonth(options) {
    const { date } = options;
    const newDate = dateFnsStartOfMonth(date);
    return transformDateWithOriginalTime({ originalDate: date, newDate });
}
export function endOfMonth(options) {
    const { date } = options;
    const newDate = dateFnsEndOfMonth(date);
    return transformDateWithOriginalTime({ originalDate: date, newDate });
}
export function startOfWeek(options) {
    const { date, weekStartsOn } = options;
    const newDate = dateFnsStartOfWeek(date, { weekStartsOn });
    return transformDateWithOriginalTime({ originalDate: date, newDate });
}
export function endOfWeek(options) {
    const { date, weekStartsOn } = options;
    const newDate = dateFnsEndOfWeek(date, { weekStartsOn });
    return transformDateWithOriginalTime({ originalDate: date, newDate });
}
export function startOfDay(options) {
    const { date } = options;
    const newDate = dateFnsStartOfDay(date);
    return transformDateWithOriginalTime({ originalDate: date, newDate });
}
export function endOfDay(options) {
    const { date } = options;
    const newDate = dateFnsEndOfDay(date);
    return transformDateWithOriginalTime({ originalDate: date, newDate });
}
export function eachDayOfInterval(options) {
    const { start, end } = options;
    return dateFnsEachDayOfInterval({ start, end }).map((date) => {
        const nextDate = new Date(date);
        nextDate.setHours(start.getHours());
        nextDate.setMinutes(start.getMinutes());
        nextDate.setSeconds(start.getSeconds());
        nextDate.setMilliseconds(start.getMilliseconds());
        return nextDate;
    });
}
export function eachWeekOfInterval(options) {
    const { start, end, weekStartsOn } = options;
    return dateFnsEachWeekOfInterval({ start, end }, { weekStartsOn }).map((date) => {
        const nextDate = new Date(date);
        nextDate.setHours(start.getHours());
        nextDate.setMinutes(start.getMinutes());
        nextDate.setSeconds(start.getSeconds());
        nextDate.setMilliseconds(start.getMilliseconds());
        return nextDate;
    });
}
export function deriveDays(options) {
    const { date, weekStartsOn } = options;
    return eachDayOfInterval({
        start: startOfWeek({ date, weekStartsOn }),
        end: endOfWeek({ date, weekStartsOn }),
    });
}
export function deriveWeeks(options) {
    const { date, weekStartsOn } = options;
    return eachWeekOfInterval({
        start: startOfMonth({ date }),
        end: endOfMonth({ date }),
        weekStartsOn,
    });
}
export function deriveYears(options) {
    const { date, total } = options;
    const pastDate = addYears(startOfYear({ date }), -total);
    return Array.from(new Array(total * 2), (_, offset) => addYears(startOfYear({ date: pastDate }), offset));
}
export function getWeekdays(options) {
    const { date, weekStartsOn } = options;
    return eachDayOfInterval({
        start: startOfWeek({ date, weekStartsOn }),
        end: endOfWeek({ date, weekStartsOn }),
    });
}
export function isYearDisabled(options) {
    const { date, min, max } = options;
    if (min && isBefore(date, min) && !isSameYear(date, min)) {
        return true;
    }
    if (max && isAfter(date, max) && !isSameYear(date, max)) {
        return true;
    }
    return false;
}
export function isDateDisabled(options) {
    const { date, min, max } = options;
    if (min && isBefore(date, min) && !isSameDay(date, min)) {
        return true;
    }
    if (max && isAfter(date, max) && !isSameDay(date, max)) {
        return true;
    }
    return false;
}
